
export const StylizeVideoCamera = (video) => {
  video.style.width = '100%';
  video.style.height = '100%';
};

